<header class="fixed-header">
  <bc-header [menuInteraction]="false">
    <bc-header-left
      [routerLink]="['/']"
      [ariaLabelogo]="ariaLabelogo"
      [ariaLabelChannel]="ariaLabelChannelName"
      logoName="bancolombia-horizontal"
      channelName="Listas de Control"
    >
    </bc-header-left>
    <bc-header-list>
      <div class="bc-flex bc-align-items-center bc-px-4">
        <p
          bc-avatar
          class="bc-bg-light bc-flex bc-align-items-center bc-justify-content-center bc-fw-bold"
        >
          {{ nameAbreviation }}
        </p>
        <p class="bc-ps-2">{{ loggedInUserName }}</p>
      </div>

      <bc-header-item
        class="bc-reverse-d-lg-none"
        icon="quit"
        text="Cerrar sesión"
        (click)="logout()"
        (keydown)="logout()"
        itemType="logout"
      >
      </bc-header-item>
    </bc-header-list>
  </bc-header>
</header>
<div class="height-80"></div>

<div class="bc-container">
  <router-outlet></router-outlet>
</div>

<bc-footer
  [isBancoLogoBottom]="true"
  [bottomTextLeftContent]="footer4.bottomTextLeftContent"
>
</bc-footer>
